/**
 * KeypointPlacement domain object.
 *
 * Represents a keypoint's resolved position on the centerline.
 * Immutable after construction.
 */

import type { Vec3 } from '../types';

export class KeypointPlacement {
    constructor(
        /** Keypoint ID from template (e.g. "P2") */
        readonly keypointId: string,
        /** Centerline node ID where this keypoint is placed */
        readonly nodeId: number,
        /** World position (copied from the node for convenience) */
        readonly worldPosition: Vec3,
        /** Whether this was manually repositioned by the user */
        readonly isEdited: boolean
    ) {
        Object.freeze(this);
    }

    /** Create an edited copy with a new node position. */
    withNode(nodeId: number, worldPosition: Vec3): KeypointPlacement {
        return new KeypointPlacement(this.keypointId, nodeId, worldPosition, true);
    }

    /** Create a copy reset to a given (original) position. */
    withReset(nodeId: number, worldPosition: Vec3): KeypointPlacement {
        return new KeypointPlacement(this.keypointId, nodeId, worldPosition, false);
    }
}
